/**
 * Toggle Wishlist with Context Action
 * Triggered by: arc:action:toggleWishlistWithContext
 * Simple trigger that delegates to useCustomerWishlist hook
 */

export const runToggleWishlistWithContext = async (data = {}) => {
    try {
        console.log('Triggering wishlist toggle with data:', data);

        // Dispatch event to be handled by useCustomerWishlist hook
        window.dispatchEvent(new CustomEvent('arc:wishlist:toggle', {
            detail: data
        }));

        return {
            success: true,
            message: 'Wishlist toggle triggered successfully'
        };

    } catch (error) {
        console.error('Wishlist toggle trigger error:', error);

        return {
            success: false,
            error: error.message
        };
    }
};

// Legacy exports for backward compatibility
export const getWishlist = () => {
    const wishlistProducts = JSON.parse(localStorage.getItem('wishlist_products') || '[]');
    return wishlistProducts;
};

export const getWishlistCount = () => {
    const wishlistProducts = JSON.parse(localStorage.getItem('wishlist_products') || '[]');
    return wishlistProducts.length;
};

export const isItemInWishlist = (productId) => {
    const wishlistProducts = JSON.parse(localStorage.getItem('wishlist_products') || '[]');
    return wishlistProducts.some(product =>
        parseInt(product.id) === parseInt(productId)
    );
};

export default runToggleWishlistWithContext;
